"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 32.62 24",
    width: "32.62",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m32 0h-31.33a.67.67 0 0 0 -.67.67v22.66a.67.67 0 0 0 .67.67h31.33a.67.67 0 0 0 .67-.67v-22.66a.67.67 0 0 0 -.67-.67zm-9.4 6.13v-2.67h8v2.67zm8 4v2.68h-8v-2.67zm-8 6.69h8v2.68h-8zm-21.03-15.26h18.3v20.87h-18.3z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.16 17.46v-10.95l9.12 5.47z",
    fill: "#9ece06"
  }));
};

exports["default"] = _default;